import cn from 'classnames';
import classes from './index.module.scss';

type Props = {
  className?: string;
};

const ZrpImage = ({ className }: Props) => (
  <div role="presentation" className={cn(classes.image, className)} /> //NOSONAR
);

export default ZrpImage;
